import ZonePage from '../pages/crud/ZonePage'
import LocationPage from '../pages/crud/LocationPage'
import LocalityPage from '../pages/crud/LocalityPage'

const routes = [
       
     {
        name: 'ZonePage', 
        path: '/crud/zone', 
        component: ZonePage,  
        meta: {
            requiresAuth: true,
            permission: "ZONE_SHOW"
        }
     },
   
     {
        name: 'LocationPage', 
        path: '/crud/location', 
        component: LocationPage,  
        meta: {
            requiresAuth: true,
            permission: "LOCATION_SHOW"
        }
     },
   
     {
        name: 'LocalityPage', 
        path: '/crud/locality', 
        component: LocalityPage,  
        meta: {
            requiresAuth: true,
            permission: "LOCALITY_SHOW"
        }
     }
]

export default routes;
